import React, { useState } from 'react';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setBranchId } from '../../../auth/actions';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Dropdown } from '../../../../common/ui';
import SupplierTable from './SupplierTable';

const Suppliers = ({ setBranchId, auth: { branchList, branchId } }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const onClickNewSupplier = () => {
    navigate('/inventory/suppliers/new-supplier');
  };

  const branchOptions = (branchList || []).map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleChangeBranch = (value) => {
    setBranchId(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle}>Suppliers</h1>
          <p className={styles.breadcrumb}>Inventory / Suppliers</p>
        </div>
        {branchId != null && branchOptions.length > 0 && (
          <div className={styles.branchWrap}>
            <Dropdown
              label="Branch"
              options={branchOptions}
              value={branchId}
              onChange={handleChangeBranch}
              placeholder="Select branch"
            />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.card}>
          <div className={styles.toolbar}>
            <div className={styles.toolbarLeft}>
              <Button onClick={onClickNewSupplier}>New Supplier</Button>
            </div>
            <div className={styles.searchWrap}>
              <Input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(value) => setSearchTerm(value)}
              />
            </div>
          </div>
          <div className={styles.tableWrap}>
            <SupplierTable searchTerm={searchTerm} />
          </div>
        </div>
      </div>
    </div>
  );
};

Suppliers.propTypes = {
  setBranchId: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    branchList: PropTypes.array,
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
});

export default connect(mapStateToProps, {
  setBranchId,
})(Suppliers);
